/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consultation_TitleInputs */

const et_consultation_title = /** @type {(inputs: Consultation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasuta konsultatsioon — ScalingWebs`)
};

const en_consultation_title = /** @type {(inputs: Consultation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Consultation — ScalingWebs`)
};

/**
* | output |
* | --- |
* | "Free Consultation — ScalingWebs" |
*
* @param {Consultation_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const consultation_title = /** @type {((inputs?: Consultation_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consultation_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_consultation_title(inputs)
	return en_consultation_title(inputs)
});